export default __webpack_public_path__ + "static/media/vf-attachment-added.dda81bbd.svg";